import PropTypes from 'prop-types';
import React from 'react';
import { deprecate } from 'react-is-deprecated';
import clsx from 'clsx';
import Glyphicon from '../Glyphicon/index.js';
import Button from '../Button/index.js';
import Link from '../Link/index.js';
import PartnerLink from '../PartnerLink/index.js';

/**
 * LinkIcon is used for displaying a hyperlink with an associated Glyphicon (`offsite` by default).
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function LinkIcon(_ref) {
  let {
    componentClass,
    children,
    label,
    // Deprecated
    placement = 'after',
    glyph = 'offsite',
    glyphClassName,
    undecorated = false,
    ...rest
  } = _ref;
  // Generate an initial content array from component's children
  const content = React.Children.toArray(children);

  // If label is supplied we need to up push it to existing content
  if (label) {
    content.push(/*#__PURE__*/_jsx(React.Fragment, {
      children: label
    }, "linkIcon-label"));
  }
  const hasHref = !!rest?.href;
  let bsStyle = undecorated ? 'text' : 'text-decorated';
  if (rest?.inverse) {
    bsStyle = `${bsStyle}-inverse`;
  }
  let Component = Button;
  if (rest.partner) {
    Component = PartnerLink;
  } else if (hasHref) {
    Component = Link;
    delete rest.bsStyle;
  } else {
    delete rest.target;
    delete rest.external;
    delete rest.inverse;
  }
  const glyphicon = /*#__PURE__*/_jsx(Glyphicon, {
    glyph: glyph,
    className: clsx({
      'margin-right-1': placement !== 'after',
      'margin-left-1': placement === 'after'
    }, glyphClassName),
    title: glyph === 'offsite' ? '(external)' : undefined
  }, glyph + placement);
  return /*#__PURE__*/_jsxs(Component, {
    "data-cmp": rest.partner ? undefined : 'linkIcon',
    ...rest,
    ...(!hasHref ? {
      bsStyle
    } : {
      undecorated
    }),
    children: [placement !== 'after' && glyphicon, content, placement === 'after' && glyphicon]
  });
}
export default LinkIcon;